import React from 'react';
export function WhyMetaAdsSection() {
  return <section className="mb-16 animate-on-scroll" data-id="element-278">
      <h2 className="text-[24px] md:text-[28px] font-bold mb-6 text-black lg:text-left text-center" data-id="element-279">
        Why Meta Ads Work for PE Deal Sourcing
      </h2>
      <div className="text-[16px] md:text-[18px] text-black space-y-5 leading-relaxed" data-id="element-280">
        <p data-id="element-281">
          While 99% of PE firms are cold-calling the same 500 business owners,
          Meta's algorithm tracks 3+ billion users across thousands of
          behavioral data points.
        </p>
        <p data-id="element-282">The platform knows exactly which business owners are:</p>
        <ul className="space-y-3 pl-5" data-id="element-283">
          <li className="flex items-start" data-id="element-284">
            <span className="mr-2" data-id="element-285">•</span>
            <span data-id="element-286">Researching succession planning</span>
          </li>
          <li className="flex items-start" data-id="element-287">
            <span className="mr-2" data-id="element-288">•</span>
            <span data-id="element-289">Using business valuation calculators</span>
          </li>
          <li className="flex items-start" data-id="element-290">
            <span className="mr-2" data-id="element-291">•</span>
            <span data-id="element-292">Reading exit strategy content</span>
          </li>
          <li className="flex items-start" data-id="element-293">
            <span className="mr-2" data-id="element-294">•</span>
            <span data-id="element-295">Showing behavioral patterns of motivated sellers</span>
          </li>
        </ul>
        <p className="font-medium" data-id="element-296">
          The result? Instead of interrupting busy owners with cold calls,
          you're reaching motivated sellers who are already considering a sale -
          before they ever talk to a broker.
        </p>
      </div>
    </section>;
}